import axios from "../axios";

export function getEnrichForm(email) {
    return axios.post(`enrich-form`, { email }).then(({ data }) => data);
}
